import { ajax } from '@/api/ajax';

export interface ArticleDetailReq {
  /**
   * 文章编码
   */
  topicCode?: string;
  topicVersion?: string;
  bookmapCode?: string;
  bookmapVersion?: string;
}

export interface ArticleDetailResponse {
  /**
   * 文章详情 HTML 字符串
   */
  content: string;
  /**
   * 工时列表
   */
  workItemList?: WorkItem[];
}
export interface WorkItem {
  /**
   * 地区
   */
  region?: string;
  /**
   * 工时编码
   */
  wiCode?: string;
  /**
   * 序号
   */
  wiIndex?: number;
  /**
   * 工时名称
   */
  wiName?: string;
}

export function getArticleDetail(data: ArticleDetailReq) {
  return ajax<ArticleDetailResponse>({
    url: '/api/tis/web/bookmap/topic/info',
    method: 'post',
    data: data
  });
}
